/* World Feast: welcome offer plumbing, loaded on every page by snippets/wf-offer-bar.liquid.
 *
 *  1. Auto-apply FEASTING once per session to new visitors (POST /cart/update.js with ONLY {discount}).
 *  2. Keep window.WF.discount in sync with /cart.js and show the "Discount automatically applied" notes.
 *  3. Wire the site-wide offer bar click (apply, then scroll to the builder or go to /pages/feast#wfad-pick).
 *
 * Rules (Ben, 14 Oct 2026):
 *  - A different code already on the cart is left alone (first code wins).
 *  - A stored /discount/<other code> cookie is left alone.
 *  - Signed-in customers with orders, and browsers carrying wf_returning=1, never get it applied.
 *  - We never GET /discount/FEASTING (it creates carts and races the cart-token stamping in theme.liquid).
 *  - Telemetry is anonymous, through window.WF.event only.
 * Works whether or not the optional custom pixel (docs/conversion-oct-2026/custom-pixel-returning.js) exists.
 */
(function () {
  'use strict';
  if (window.__wfOfferLoaded) return;
  window.__wfOfferLoaded = true;

  var cfg = window.WF_OFFER_CFG || {};
  var CODE = String(cfg.code || 'FEASTING').toUpperCase();
  // Codes that are dead (expired or deleted). An old link can leave one stored or on the cart; it must not
  // count as "the customer already has a code" or they lose the welcome offer and hit an invalid code at checkout.
  var DEAD_CODES = ['FEASTING20'];
  function isDead(c) { return DEAD_CODES.indexOf(String(c || '').toUpperCase()) !== -1; }
  var SESSION_FLAG = 'wf_offer_autoapply_done';
  var BAR_SHOWN_FLAG = 'wf_offer_bar_shown';

  var WF = (window.WF = window.WF || {});
  var state = (WF.discount = { code: CODE, onCart: false, applicable: false, otherCode: false, status: 'unknown' });

  function ev(name, data) {
    try { if (window.WF && typeof window.WF.event === 'function') window.WF.event(name, data || {}); } catch (e) { /* telemetry must never break the page */ }
  }
  function ssGet(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
  function ssSet(k, v) { try { sessionStorage.setItem(k, v); } catch (e) { /* private mode */ } }
  function cookie(name) {
    var m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : '';
  }

  /* ── eligibility ─────────────────────────────────────────── */
  function isReturning() {
    if (cfg.customerOrders > 0) return true;
    if (cookie('wf_returning') === '1') return true;
    try { if (localStorage.getItem('wf_returning') === '1') return true; } catch (e) { /* ignore */ }
    return false;
  }

  /* ── cart state ──────────────────────────────────────────── */
  var internalWrites = 0; // our own /cart/update.js calls, so the fetch hook does not loop on them

  function getCart() {
    return fetch('/cart.js', { cache: 'no-store', credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }

  function publish(cart) {
    var codes = (cart && Array.isArray(cart.discount_codes)) ? cart.discount_codes : [];
    var mine = null;
    var other = false;
    codes.forEach(function (d) {
      if (String(d.code || '').toUpperCase() === CODE) mine = d; else if (!isDead(d.code)) other = true;
    });
    state.onCart = !!mine;
    state.applicable = !!(mine && mine.applicable);
    state.otherCode = other;
    state.status = state.applicable ? 'applied' : (state.onCart ? 'pending' : 'none');
    syncNotes();
    syncCardPrices();
    try { document.dispatchEvent(new CustomEvent('wf:discount', { detail: state })); } catch (e) { /* old browsers */ }
    return state;
  }

  function refresh() {
    return getCart().then(publish).catch(function () { return state; });
  }

  /* ── notes under the buttons ─────────────────────────────── */
  function syncNotes() {
    var notes = document.querySelectorAll('[data-wf-discount-note]');
    for (var i = 0; i < notes.length; i++) {
      var n = notes[i];
      if (n.getAttribute('data-wf-dn') === state.status) continue;
      n.setAttribute('data-wf-dn', state.status);
      var applied = n.querySelector('.wf-discount-note__applied');
      var pending = n.querySelector('.wf-discount-note__pending');
      if (applied) applied.hidden = state.status !== 'applied';
      if (pending) pending.hidden = state.status !== 'pending';
      n.hidden = !(state.status === 'applied' || state.status === 'pending');
    }
  }

  /* ── struck prices on the box cards (Ben, 16 Oct 2026) ─────────
   * While FEASTING is on the cart (applied, or pending because a box in the basket always qualifies for 15%),
   * each card's total and per-head price shows the normal price struck through, the price after 15% beside it,
   * and a small "Discount applied" label. Nothing here changes what is added or charged: the configurator's own
   * elements keep their text (so its tests and maths are untouched). We only set data-wf-new="£x" on them, and
   * the CSS in snippets/wf-offer-bar.liquid draws the struck original plus the new figure from that attribute.
   * Attributes survive the configurator re-writing the text, and the MutationObserver below re-reads on every
   * text change (a microtask, before paint), so a group-size change never shows a stale figure. */
  var CARD_OFF = 15; // per cent, mirrors the FEASTING code
  function penceOf(txt) {
    var m = /\u00a3\s*([\d,]+(?:\.\d+)?)/.exec(txt || '');
    return m ? Math.round(parseFloat(m[1].replace(/,/g, '')) * 100) : 0;
  }
  function fmtPence(p) { var pounds = p / 100; return '\u00a3' + (pounds % 1 === 0 ? pounds : pounds.toFixed(2)); }
  // newPence (optional) overrides the 15% sum, so the per-head figure can be derived from the discounted total
  // (4 x £18.28 would otherwise not add up to £73.10). Screen readers get "Was £x, now £y" via aria-label.
  function setNew(el, on, orig, newPence) {
    if (!el) return;
    var want = null;
    if (on) {
      var p = penceOf(orig);
      if (p > 0) want = fmtPence(newPence > 0 ? newPence : Math.round(p * (100 - CARD_OFF) / 100));
    }
    if (want) {
      if (el.getAttribute('data-wf-new') !== want) el.setAttribute('data-wf-new', want);
      var subEl = el.querySelector('.cuisine-tier-total-sub');
      var label = 'Was ' + fmtPence(penceOf(orig)) + ', now ' + want + (subEl ? ', ' + subEl.textContent.trim() + ', discount applied' : '');
      if (el.getAttribute('aria-label') !== label) { el.setAttribute('aria-label', label); el.setAttribute('role', 'text'); }
    } else if (el.hasAttribute('data-wf-new')) {
      el.removeAttribute('data-wf-new'); el.removeAttribute('aria-label'); el.removeAttribute('role');
    }
  }
  function syncCardPrices() {
    // 'pending' = FEASTING on the cart but not yet applicable. A returning customer can carry the code that way
    // (typed in the drawer, an ad link) and the welcome-offer Function will never apply it, so no struck prices.
    var on = state.status === 'applied' || (state.status === 'pending' && !isReturning());
    var boxes = document.querySelectorAll('[data-cuisine-tiers] .cuisine-tier-buybox');
    for (var i = 0; i < boxes.length; i++) {
      var amt = boxes[i].querySelector('.cuisine-tier-price-amount');
      var tot = boxes[i].querySelector('.cuisine-tier-price-total');
      var totAmt = tot && tot.querySelector('.cuisine-tier-total-amt');
      var totP = penceOf(totAmt && totAmt.textContent);
      var sub = tot && tot.querySelector('.cuisine-tier-total-sub');
      var size = sub ? parseInt((/(\d+)/.exec(sub.textContent) || [])[1], 10) : 0;
      var newTot = totP > 0 ? Math.round(totP * (100 - CARD_OFF) / 100) : 0;
      setNew(amt, on, amt && amt.textContent, newTot > 0 && size > 0 ? Math.round(newTot / size) : 0);
      setNew(tot, on, totAmt && totAmt.textContent, newTot);
    }
  }
  try {
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var t = muts[i].target;
        if (t && t.nodeType === 3) t = t.parentNode;
        if (t && t.closest && (t.closest('.cuisine-tier-buybox') || (t.matches && t.matches('[data-cuisine-tiers]')))) { syncCardPrices(); return; }
        // a whole builder injected (the /pages/feast landing) or a card re-rendered
        var added = muts[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          if (added[j].nodeType === 1 && added[j].querySelector && (added[j].querySelector('.cuisine-tier-buybox') || added[j].classList.contains('cuisine-tier-buybox'))) { syncCardPrices(); return; }
        }
      }
    }).observe(document.documentElement, { childList: true, characterData: true, subtree: true });
  } catch (e) { /* no MutationObserver */ }

  /* ── auto-apply ──────────────────────────────────────────── */
  var inflight = null;

  // opts.force: skip the once-per-session flag (an explicit click on the offer bar). Every other rule still applies.
  function ensureApplied(opts) {
    opts = opts || {};
    if (inflight) return inflight;
    inflight = Promise.resolve(WF.__cartTokenReady)
      .catch(function () { /* stamping failed: carry on */ })
      .then(getCart)
      .then(function (cart) {
        publish(cart);
        if (state.onCart) return state;                 // already there
        if (state.otherCode) return state;              // first code wins
        if (isReturning()) return state;                // returning customer or marker
        var stored = cookie('discount_code').toUpperCase();
        if (stored && stored !== CODE && !isDead(stored)) return state;    // a /discount/<code> link was used: respect it (unless the code is dead)
        if (!opts.force && ssGet(SESSION_FLAG)) return state;
        ssSet(SESSION_FLAG, '1');
        internalWrites++;
        // ONLY the discount key: Shipping-Date, _wf_* attributes and Zapiet data are not touched.
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ discount: CODE })
        })
          .then(function (r) {
            // A failed write (e.g. 429 rate limit) must not use up the session's one try:
            // clear the flag so the next page view retries.
            if (!r.ok) { try { sessionStorage.removeItem(SESSION_FLAG); } catch (e) {} throw new Error('cart/update ' + r.status); }
            return r.json();
          })
          .then(function (c) { return (c && Array.isArray(c.discount_codes)) ? c : getCart(); })
          .then(function (c) {
            publish(c);
            ev('discount_autoapplied', { applicable: state.applicable });
            return state;
          })
          .catch(function () { return state; })
          .then(function (s) { internalWrites--; return s; });
      })
      .catch(function () { return state; })
      .then(function (s) { inflight = null; return s; });
    return inflight;
  }

  WF.offer = { ensureApplied: ensureApplied, refresh: refresh, syncNotes: syncNotes, syncCardPrices: syncCardPrices };

  /* ── keep the state live when the cart changes ───────────── */
  var refreshTimer = null;
  function scheduleRefresh() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(refresh, 250);
  }

  var nativeFetch = window.fetch;
  if (typeof nativeFetch === 'function') {
    window.fetch = function (input) {
      var url = '';
      try { url = typeof input === 'string' ? input : (input && input.url) || ''; } catch (e) { /* ignore */ }
      var p = nativeFetch.apply(this, arguments);
      if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url) && !internalWrites) {
        p.then(scheduleRefresh, function () {});
      }
      return p;
    };
  }

  // AMP slide cart callback: wrap (never replace) so theme.liquid's handler and the telemetry wrapper keep running.
  function wrapSlideUpdated() {
    var cur = window.SLIDECART_UPDATED;
    if (cur && cur.__wfOfferWrapped) return;
    var wrapped = function () {
      var r;
      if (typeof cur === 'function') { try { r = cur.apply(this, arguments); } catch (e) { /* keep going */ } }
      scheduleRefresh();
      return r;
    };
    wrapped.__wfOfferWrapped = true;
    window.SLIDECART_UPDATED = wrapped;
  }
  wrapSlideUpdated();
  window.addEventListener('load', wrapSlideUpdated);

  // Builders inject their markup later (the /pages/feast landing loads a cuisine builder into itself).
  var moTimer = null;
  try {
    new MutationObserver(function () {
      clearTimeout(moTimer);
      moTimer = setTimeout(syncNotes, 150);
    }).observe(document.documentElement, { childList: true, subtree: true });
  } catch (e) { /* no MutationObserver */ }

  /* ── offer bar ───────────────────────────────────────────── */
  function headerOffset() {
    var h = document.querySelector('.section-header') || document.querySelector('.header-wrapper');
    return h ? h.offsetHeight : 0;
  }

  function scrollToEl(el) {
    var reduce = false;
    try { reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) { /* ignore */ }
    var top = el.getBoundingClientRect().top + window.pageYOffset - headerOffset() - 8;
    window.scrollTo({ top: Math.max(0, top), behavior: reduce ? 'auto' : 'smooth' });
    // focus without a second scroll so keyboard users land in the section
    try { if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '-1'); el.focus({ preventScroll: true }); } catch (e) { /* ignore */ }
  }

  function initBar() {
    var bar = document.querySelector('[data-wf-offer-bar]');
    if (!bar) return;

    // Tell the CSS how tall the bar really is (transparent-header pages clear it).
    function measure() {
      document.documentElement.style.setProperty('--wf-offer-bar-h', bar.offsetHeight + 'px');
    }
    measure();
    try { new ResizeObserver(measure).observe(bar); } catch (e) { window.addEventListener('resize', measure); }

    if (!ssGet(BAR_SHOWN_FLAG)) {
      ssSet(BAR_SHOWN_FLAG, '1');
      ev('offer_bar_shown', { page: location.pathname });
    }

    var link = bar.querySelector('[data-wf-offer-bar-link]');
    if (!link) return;
    link.addEventListener('click', function (e) {
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return; // let "open in new tab" work
      var pick = document.getElementById('wfad-pick');
      var tiers = document.getElementById('tiers');
      var target = pick || tiers;
      var action = target ? 'scroll' : 'navigate';
      ev('offer_bar_clicked', { page: location.pathname, action: action });
      var applying = ensureApplied({ force: true });
      e.preventDefault();
      if (target) {
        scrollToEl(target);
        return;
      }
      // Navigating away: give the cart write a moment to finish so the request is not cancelled.
      var go = function () { window.location.href = (cfg.feastPath || '/pages/feast') + (cfg.pickAnchor || '#wfad-pick'); };
      var done = false;
      var once = function () { if (!done) { done = true; go(); } };
      applying.then(once, once);
      setTimeout(once, 1500);
    });
  }

  /* ── boot ────────────────────────────────────────────────── */
  function boot() {
    initBar();
    syncNotes();
    syncCardPrices();
    ensureApplied();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
